import React from 'react';
import { useAppSelector } from '../../../stores/redux.store';
import { useRegisterComponent } from '../../orchestrator';
import { useMarketingConsentContext } from '../contexts/LoginMarketingConsentContext';

import { StyledMarketingConsent } from './styled';

export const LoginMarketingConsent = () => {
  useRegisterComponent(LoginMarketingConsent.name);

  const config = useAppSelector(state => state.marketingConsent?.config);
  const isUsernameChecked = useAppSelector(state => state.login?.isUsernameChecked);

  const { setMarketingConsent } = useMarketingConsentContext();

  if (!isUsernameChecked) {
    return null;
  }

  return <StyledMarketingConsent config={config} onConsentChange={setMarketingConsent} />;
};
